/**
 * Component: My Plans Page with Container + View Pattern
 *
 * This is a component-level file that delegates to the centralized
 * Container + View pattern for clean separation of concerns
 */
import MyPlansPageContainer from "./MyPlansPage.container";
import type { V32UITier } from '../../types/subscription';

interface MyPlansPageProps {
  onViewPlan: (planId: string) => void;
  onCreateNew: () => void;
  currentTier: V32UITier;
  plans?: any[];
  usageStatus?: any;
  isGenerating?: boolean;
  onRefetchPlans?: () => Promise<void> | void;
}

export function MyPlansPage(props: MyPlansPageProps) {
  // Component level just delegates to container - clean and simple
  return <MyPlansPageContainer {...props} />;
}
